import { Box, Typography } from "@mui/material";

export default function DescriptionTab({ data }) {
  console.log("DescriptionTab data:", data);
  return (
    <Box>
      {/* <Typography variant="h6" mb={1}>Course Description</Typography> */}
      <Typography fontSize={14} color="text.secondary">
       {data?.description || "No description available."}
      </Typography>
    </Box>
  );
}
